import { render, staticRenderFns } from "./CardDownloadList.vue?vue&type=template&id=d54a07ea"
import script from "./CardDownloadList.vue?vue&type=script&lang=js"
export * from "./CardDownloadList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports